import "./Header.scss";
import { FaChevronDown } from "react-icons/fa";
import { FiCalendar } from "react-icons/fi";
import { FiMapPin } from "react-icons/fi";
import { Tag, Avatar } from "antd";
import { useLocation } from "react-router-dom";

// Generate a color based on the name
const getAvatarColor = (name) => {
  const colors = [
    "#f56a00", "#7265e6", "#ffbf00", "#00a2ae",
    "#87d068", "#ff4d4f", "#2db7f5", "#108ee9"
  ];
  if (!name) return colors[0];
  return colors[name.charCodeAt(0) % colors.length];
};

const Header = () => {
  const loginTime = localStorage.getItem("loginTime")
  const userName = localStorage.getItem("cashier")
  const location = useLocation();
  const pathRoadMap = {
    "/order-processing/menu": "Order Line",
    "/order-processing/saved": "Saved Orders",
    "/order-processing/new": "New Orders",
    "/order-processing/calendar": "Working Shift",
    "/order-processing/completed": "Completed",
  }
  return (
    <div className="header">
      {/* Left side */}
      <div className="header-left">
        <div className="frame-title-tab-header">
          <Tag color="blue">{pathRoadMap[location.pathname]}</Tag>
        </div>
        <hr />

        {/* <div className="logo">
          <img
            src="https://i.pravatar.cc/150?img=2"
            alt="logo"
            className="logo-img"
          />
          <span className="logo-text">Owner</span>
        </div>
        <div className="status active">
          <Tag color="green" className="frame-tag-active">
            <div className="circle-active" /> <span>Active</span>
          </Tag>
        </div> */}

        {/* 20:20 PM */}
      </div>

      {/* Right side */}
      <div className="header-right">
        <div className="datetime">
          <FiMapPin className="icon" />
          <span>
            {localStorage.getItem("selectedLocation") || "No location selected"}
          </span>
        </div>
        <div className="datetime">
          <FiCalendar className="icon" />
          <span>{loginTime}</span>
        </div>
        <div className="profile">
          <Avatar
            className="avatar"
            style={{ backgroundColor: getAvatarColor(userName) }}
          >
            {userName ? userName.charAt(0).toUpperCase() : "U"}
          </Avatar>
          <span className="username">{userName}</span>
          {/* <FaChevronDown className="icon" /> */}
        </div>
      </div>
    </div>
  );
};

export default Header;
